/* eslint-disable no-unused-vars */
import axios from 'axios';
import { useAppDispatch } from 'store/hooks';
import { setGlobalLoadingCounter } from 'store/page/pageSlice';
import { Resource } from 'store/types';

export const useDownloadHandler = ({
  contextItem,
}: {
  contextItem: Resource | null;
}) => {
  const dispatch = useAppDispatch();

  return async () => {
    if (!contextItem) {
      return;
    }

    dispatch(setGlobalLoadingCounter(1));
    const response = await axios.get<any>(
      `${contextItem.link}?no_redirect=true`
    );
    const image = await fetch(response.data.link);
    const imageBlob = await image.blob();
    const imageURL = URL.createObjectURL(imageBlob);

    const link = document.createElement('a');
    link.href = imageURL;
    link.download = contextItem.name || 'image.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    dispatch(setGlobalLoadingCounter(0));
  };
};
